<template>
  <div class="BizXfThemepack" v-if="themePackList.length>0">
    <div
      v-for="(item, index) in themePackList"
      :key="index"
      :style="{ background: bgArr[index] }"
      :class="[
        'themepack-item',
        {'themepack-item_marginleft': index%2 === 1},
        {'themepack-item_marginright': index%2 === 0},
        {'themepack-item_marginbottom': index < 2},
        {'themepack-item_margintop': index >= 2}]"
      @click.prevent="themePackClick(item, index, fromSoj)"
    >
    <a hidden :href="item.url"></a>
      <span class="themepack-desc">
        <span class="themepack-title ellipsis"> {{ item.name }}</span>
        <span class="themepack-subTitle ellipsis">{{ item.desc }}</span>
      </span>
      <span :class="[item.image_name, 'themepack-img']"/>
    </div>
  </div>
</template>
<script>
import { concatSoj } from '../../utils/common/base';

export default {
  name: 'BizXfThemepack',
  props: {
    /**
     * 主题包数据示例
     *[{
        name: '新盘抢鲜',
        desc: '新盘在建中，先睹为快',
        image_name: 'theme_pack_1',
        url: 'https://m.anjuke.com/sh/xinfang/fuwu/theme/1041/',
      }]
     */
    themePackList: { // 主题包数据
      type: Array,
      required: true,
      default: () => [],
      validate(value) {
        return (Object.prototype.toString.call(value) === '[object Array]');
      },
    },
    fromSoj: {// from码
      type: String,
      default: '',
    },
    themePackClick: {// 点击跳转事件
      type: Function,
      default: (item, index, fromSoj) => {
        window.location.href = concatSoj(item.url, fromSoj);
      },
    },
  },
  data() {
    return {
      bgArr: ['#F1F6F7', '#FBFAF2', '#FAF8F5', '#F4F8F3'],
    };
  },
  methods: {
  },
};
</script>
<style scoped>
  .BizXfThemepack {
    overflow: hidden;
  }
  .BizXfThemepack .themepack-item {
    display: block;
    position: relative;
    float: left;
    width: calc(50% - 2px);
  }
  .BizXfThemepack .themepack-desc {
    display: block;
    float: left;
    width: calc(100% - 12px);
    padding: 24px 0 20px 12px;
    position: relative;
    z-index: 1;
  }
  .BizXfThemepack .ellipsis {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .BizXfThemepack .themepack-title {
    display: block;
    font-size: 16px;
    color: #1f2326;
    line-height: 16px;
    margin-right: 60px;
  }
  .BizXfThemepack .themepack-subTitle {
    display: block;
    margin-top: 8px;
    font-size: 11px;
    color: #9aa0a6;
    margin-right: 60px;
    line-height: 12px;
  }
  .BizXfThemepack .themepack-item_marginleft {
    margin-left: 2px;
  }
  .BizXfThemepack .themepack-item_marginright {
    margin-right: 2px;
  }
  .BizXfThemepack .themepack-item_marginbottom {
    margin-bottom: 2px;
  }
  .BizXfThemepack .themepack-item_margintop {
    margin-top: 2px;
  }
    /*背景图 start*/
  .BizXfThemepack .themepack-img {
    position: absolute;
    right: 0;
    top: 0;
    display: block;
    background: url("https://pages.anjukestatic.com/kfstouch/xinfang-mobile/img/fuwu/loupan/theme_pack_icons.png") no-repeat;
    background-size: 280px 160px;
    z-index: 0;
    width: 70px;
    height: 80px;
  }
  .BizXfThemepack .theme_pack_1 {
    background-position: -0px -0px;
  }

  .BizXfThemepack .theme_pack_2 {
    background-position: -70px -0px;
  }

  .BizXfThemepack .theme_pack_3 {
    background-position: -140px -0px;
  }

  .BizXfThemepack .theme_pack_4 {
    width: 70px;
    height: 80px;
    background-position: -210px -0px;
  }

  .BizXfThemepack .theme_pack_rank {
    background-position: -0px -80px;
  }

  .BizXfThemepack .theme_pack_brand_zone {
    background-position: -70px -80px;
  }

  .BizXfThemepack .theme_pack_discount {
    background-position: -140px -80px;
  }
    /*背景图 end*/
</style>
